/**
 * Format a plan's yearly custom-model training usage for display.
 *
 * The backend exposes `custom_model_yearly_limit` (null = unlimited),
 * `custom_model_yearly_used` and `custom_model_yearly_remaining`. This renders a
 * single consistent string across the customer and back-office subscription
 * views, e.g. `"3 / 10"` when capped or `"3 · Unlimited"` when unlimited.
 *
 * @param used - trainings consumed this calendar year
 * @param limit - configured yearly cap, or null/undefined for unlimited
 * @param unlimitedLabel - translated label for the unlimited case
 */
export const formatCustomModelYearlyUsage = (
  used: number | null | undefined,
  limit: number | null | undefined,
  unlimitedLabel: string
): string => {
  const usedCount = used ?? 0;
  return limit != null
    ? `${usedCount} / ${limit}`
    : `${usedCount} · ${unlimitedLabel}`;
};
